import ModelUtil from '@leverege/model-util';
import { v4 } from '@leverege/base62-util';
import AggsUtil from "../util/AggsUtil.js";
const TYPE = 'aggregation.AggregationItemModel';
function create(aggregation) {
  return {
    id: v4(),
    type: TYPE,
    model: aggregation,
    name: null,
    viewModels: []
  };
}
function getName(model) {
  return model.name ? model.name : AggsUtil.aggTypeToName(model?.model?.type);
}
export default {
  create,
  TYPE,
  ...ModelUtil.createAllValue('name'),
  ...ModelUtil.createAllValue('model'),
  ...ModelUtil.createAllArray('viewModels'),
  getName
};